<div>
  <div id="main" class="col-sm-12 col-md-12 col-lg-10 col-lg-offset-1">
    <h2>404 - Page not found</h2>
    <ul>
      <li routerLinkActive="active">
        <a [routerLink]="['/companies']">Borrowers</a>
      </li>
      @if (userIsAdmin()) {
        <li routerLinkActive="active">
          <a [routerLink]="['/users']">Users</a>
        </li>
      }
      @if (userIsDeveloper() && isEnviroment) {
        <li routerLinkActive="active">
          <a [routerLink]="['/settings']">Settings</a>
        </li>
      }
      @if (shouldDisplayManualReview()) {
        <li class="manual-review-link" routerLinkActive="active">
          <a [routerLink]="['/review']">Manual Review</a>
        </li>
      }
    </ul>
  </div>
</div>
